import { render, staticRenderFns } from "./TailwindTable.vue?vue&type=template&id=4247eba6&"
import script from "./TailwindTable.vue?vue&type=script&lang=ts&"
export * from "./TailwindTable.vue?vue&type=script&lang=ts&"
import style0 from "./TailwindTable.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports